// URLs signées (api.php : signDownload / signJellyfin / verifySig).
//
// Le sceau HMAC couvre le chemin tel que PHP le décode : l'URL doit donc se
// redécoder exactement en ce chemin, séparateurs '/' compris.
//
// D'où l'encodage segment par segment : `encodeURIComponent` sur chaque nom,
// puis jointure par des '/' littéraux. Un `encodeURI` sur le chemin entier ne
// convient pas — il laisse passer '&', '#' et '+' tels quels, si bien qu'un
// fichier nommé « Action & Co » coupe la chaîne de requête, que PHP reçoit un
// chemin tronqué et que la signature est rejetée (403).
//
// Ces liens se consomment sans session ni en-tête : ils sont directement
// utilisables par une balise <img>/<video>, un lecteur natif ou un
// gestionnaire de téléchargement.

function encodeUserPath(segments){
    return segments.map(encodeURIComponent).join('/');
}

export function signedDownloadUrl(apiUrl, userLogin, pathArray, name, exp, sig){
    return apiUrl
        + '?action=download&path=' + encodeUserPath(pathArray.concat([name]))
        + '&u=' + encodeURIComponent(userLogin)
        + '&exp=' + exp + '&sig=' + sig;
}

export function jellyfinImageUrl(apiUrl, id, exp, sig){
    return apiUrl + '?action=jellyfinImage&id=' + id + '&exp=' + exp + '&sig=' + sig;
}
